<div class="report-dashboard" *ngIf="definition">
  <header class="report-header" *ngIf="showHeader">
    <div class="report-heading-icon" *ngIf="definition.iconClass"><i [class]="definition.iconClass"></i></div>
    <div>
      <h1>{{ definition.title }}</h1>
      <span class="report-print-view report-print-header-view" *ngIf="selectedPreset">
        View: {{ selectedViewDisplay }}
      </span>
      <p *ngIf="definition.description">{{ definition.description }}</p>
    </div>
    <div class="report-header-actions" [hidden]="showGrid">
      <button *ngIf="canEditDashboard" type="button" class="btn btn-secondary report-edit-button"
        [disabled]="loading" (click)="editDashboardRequested.emit()">
        <i class="fa fa-pencil"></i> Edit
      </button>
      <button *ngIf="definition.allowPrint !== false" type="button" class="btn btn-success report-print-button" [disabled]="loading" (click)="printReport()">
        <i class="fa fa-print"></i> Print / Save PDF
      </button>
    </div>
  </header>

  <div class="report-filter-bar" *ngIf="showFilterBar" [class.has-dashboard-title]="showDashboardTitle" [hidden]="showGrid">
    <div class="report-filter-heading">
      <div class="report-filter-heading-icon" *ngIf="showDashboardTitle && definition.iconClass">
        <i [class]="definition.iconClass"></i>
      </div>
      <div class="report-filter-heading-copy">
        <div class="report-filter-title-row">
          <h2 *ngIf="showDashboardTitle">{{ definition.title }}</h2>
          <span class="report-print-view" *ngIf="selectedPreset">View: {{ selectedViewDisplay }}</span>
          <span class="report-filter-title-separator" *ngIf="showDashboardTitle">-</span>
          <div class="saved-view-control">
            <div class="saved-view-picker" dropdown>
              <button type="button" class="saved-view-picker-button" dropdownToggle
                [disabled]="presetLoading || presetSaving" aria-label="Choose saved report view">
                <span>{{ selectedViewDisplay }}</span>
                <i class="fa fa-chevron-down"></i>
              </button>
              <div *dropdownMenu class="dropdown-menu saved-view-menu" role="menu">
                <button type="button" class="dropdown-item" (click)="selectPreset(null)">Dashboard defaults</button>
                <ng-container *ngIf="presetsByOwnership(PresetOwnershipType.System).length">
                  <div class="dropdown-header">Recommended</div>
                  <button type="button" class="dropdown-item" *ngFor="let preset of presetsByOwnership(PresetOwnershipType.System)"
                    (click)="selectPreset(preset.ReportFilterPresetId)">{{ preset.PresetName }}</button>
                </ng-container>
                <ng-container *ngIf="presetsByOwnership(PresetOwnershipType.FlightSchool).length">
                  <div class="dropdown-header">Flight School</div>
                  <button type="button" class="dropdown-item" *ngFor="let preset of presetsByOwnership(PresetOwnershipType.FlightSchool)"
                    (click)="selectPreset(preset.ReportFilterPresetId)">{{ preset.PresetName }}</button>
                </ng-container>
                <ng-container *ngIf="presetsByOwnership(PresetOwnershipType.User).length">
                  <div class="dropdown-header">My Views</div>
                  <button type="button" class="dropdown-item" *ngFor="let preset of presetsByOwnership(PresetOwnershipType.User)"
                    (click)="selectPreset(preset.ReportFilterPresetId)">{{ preset.PresetName }}</button>
                </ng-container>
              </div>
            </div>
            <div class="saved-view-more" dropdown placement="bottom right">
              <button type="button" class="saved-view-more-button" dropdownToggle
                [disabled]="presetSaving" aria-label="Saved view actions" title="Saved view actions">
                <i class="fa fa-ellipsis-h"></i>
              </button>
              <div *dropdownMenu class="dropdown-menu dropdown-menu-right saved-view-action-menu" role="menu">
                <button type="button" class="dropdown-item" (click)="saveView(true)"
                  [disabled]="!canSaveSelectedViewChanges">Save changes</button>
                <button type="button" class="dropdown-item" (click)="saveView(false)">Save as new</button>
                <button type="button" class="dropdown-item" (click)="editSelectedView()"
                  [disabled]="!canEditSelectedPreset">Edit</button>
                <div class="dropdown-divider" *ngIf="selectedPreset"></div>
                <button type="button" class="dropdown-item" *ngIf="selectedPreset" (click)="resetPreset()"
                  [disabled]="!presetModified">Reset</button>
                <div class="dropdown-divider"></div>
                <button type="button" class="dropdown-item" (click)="makeSelectedViewDefault()"
                  [disabled]="selectedViewIsDefault || presetSaving">
                  <i class="fa mr-2" [class.fa-star]="selectedViewIsDefault" [class.fa-star-o]="!selectedViewIsDefault"></i>
                  {{ selectedViewIsDefault ? 'Default view' : 'Make Default' }}
                </button>
                <button type="button" class="dropdown-item" (click)="manageViews()"
                  [disabled]="presetLoading || presetSaving">
                  <i class="fa fa-sliders mr-2"></i> Manage Views
                </button>
              </div>
            </div>
          </div>
        </div>
        <p *ngIf="showDashboardTitle && definition.description">{{ definition.description }}</p>
      </div>
    </div>

    <div class="chart-data-toggle" title="Choose whether report charts or their data tables display first">
      <dw-yesno
        [options]="chartDataToggleOptions"
        [ngModel]="!showChartGridFirst"
        (ngModelChange)="onShowChartGridFirstChanged(!$event)">
      </dw-yesno>
    </div>

    <div class="report-filter-row">
      <app-generic-tag-filters
        *ngIf="filterConfigs.length"
        [filterConfigs]="filterConfigs"
        [appliedFilters]="appliedFilters"
        [appliedFilterState]="currentFilterState?.filters"
        [applyConfiguredDefaultsWhenEmpty]="!selectedPreset && !hasCarriedFilters"
        [autoRefresh]="true"
        (customFilterStateChanged)="onCustomFilterStateChanged($event)"
        (filtersEdited)="onFiltersEdited()"
        (filtersChanged)="onFiltersChanged($event)">
      </app-generic-tag-filters>
    </div>
  </div>

  <section class="report-print-filters" *ngIf="printActiveFilters.length">
    <div class="report-print-filters-title">Current filters</div>
    <div class="report-print-filter-list">
      <div class="report-print-filter" *ngFor="let filter of printActiveFilters">
        <strong>{{ filter.displayLabel }}:</strong>
        <span>{{ filter.displayValue }}</span>
      </div>
    </div>
  </section>

  <div class="alert alert-danger report-preset-error" *ngIf="presetError && !showGrid">{{ presetError }}</div>
  <div class="alert alert-danger report-data-error" *ngIf="dataError && !showGrid">{{ dataError }}</div>

  <section class="metric-grid dashboard-skeleton" *ngIf="loading && skeletonTiles.length" [hidden]="showGrid"
    aria-label="Loading dashboard metrics" aria-busy="true">
    <article class="metric-card skeleton-card" *ngFor="let tile of skeletonTiles">
      <span class="skeleton-block skeleton-kpi-icon" *ngIf="tile.tileIconClass"></span>
      <span class="skeleton-block skeleton-kpi-title"></span>
      <span class="skeleton-block skeleton-kpi-value"></span>
      <span class="skeleton-block skeleton-kpi-supporting" *ngIf="tile.additionalConfig.supportingText"></span>
    </article>
  </section>

  <section class="metric-grid" *ngIf="!loading && tileResults.length" [hidden]="showGrid">
    <article class="metric-card metric-card-clickable" *ngFor="let tile of tileResults"
      role="button" tabindex="0" (click)="onTileSelected(tile)" (keydown.enter)="onTileSelected(tile)">
      <div class="metric-icon" *ngIf="tile.tileConfig.iconClass"><i [class]="tile.tileConfig.iconClass"></i></div>
      <div class="metric-title">{{ tile.tileConfig.containerTitle }}</div>
      <div class="metric-value">{{ tile.tileConfig.tileText }}</div>
      <div class="metric-supporting" *ngIf="tile.tileConfig.additionalText">{{ tile.tileConfig.additionalText }}</div>
    </article>
  </section>

  <section class="detail-panel" *ngIf="showGrid && currentDrillDown">
    <div class="detail-header">
      <div>
        <div class="detail-title">{{ selectedLabel || currentDrillDown.title }}</div>
        <div class="detail-subtitle">Page-level {{ currentDrillDown.title }} drill-down</div>
      </div>
      <button type="button" class="btn btn-link" (click)="closeGrid()">Back to dashboard</button>
    </div>
    <div class="drill-down-state" *ngIf="drillDownLoading">
      <i class="fa fa-spinner fa-spin"></i> Loading matching {{ currentDrillDown.title.toLowerCase() }}...
    </div>
    <div class="drill-down-state drill-down-message" *ngIf="!drillDownLoading && drillDownMessage">
      <i class="fa fa-info-circle"></i> {{ drillDownMessage }}
    </div>
    <dw-meta-data-grid *ngIf="!drillDownLoading && !drillDownMessage && gridFilters"
      [item]="currentDrillDown.item"
      [configKeyPart]="currentDrillDown.gridConfigKey"
      [configKeyPart2]="currentDrillDown.gridConfigKeyPart2"
      [filters]="gridFilters">
    </dw-meta-data-grid>
  </section>

  <section class="widget-grid dashboard-skeleton" *ngIf="loading && skeletonWidgets.length" [hidden]="showGrid"
    aria-label="Loading dashboard charts" aria-busy="true"
    [style.grid-template-columns]="'repeat(' + widgetGridColumnCount + ', minmax(0, 1fr))'">
    <article class="widget-card skeleton-widget-card" *ngFor="let widget of skeletonWidgets"
      [style.grid-column]="'span ' + widgetColumnSpan(widget)"
      [style.min-height.px]="widget.minimumHeightPixels">
      <div class="skeleton-widget-header">
        <span class="skeleton-block skeleton-widget-title"></span>
        <span class="skeleton-block skeleton-widget-description" *ngIf="widget.description"></span>
      </div>
      <div class="skeleton-chart-area">
        <span class="skeleton-chart-line skeleton-chart-line-one"></span>
        <span class="skeleton-chart-line skeleton-chart-line-two"></span>
        <span class="skeleton-chart-line skeleton-chart-line-three"></span>
        <div class="skeleton-chart-bars">
          <span></span><span></span><span></span><span></span><span></span>
        </div>
      </div>
    </article>
  </section>

  <div class="loading-state" *ngIf="loading && !skeletonTiles.length && !skeletonWidgets.length && !showGrid">
    <i class="fa fa-spinner fa-spin"></i> Loading report data...
  </div>

  <section class="widget-grid" *ngIf="!loading" [hidden]="showGrid"
    [style.grid-template-columns]="'repeat(' + widgetGridColumnCount + ', minmax(0, 1fr))'">

    <article class="widget-card widget-chart-card" *ngFor="let result of widgetResults"
      [style.grid-column]="'span ' + widgetColumnSpan(result.definition)"
      [style.min-height.px]="result.definition.minimumHeightPixels">
      <dw-chart-tile
        [chartPreferences]="result.chartPreferences"
        [data]="result.data"
        [gridSourceData]="result.gridData"
        [query]="result.query"
        (dataSelected)="onDataSelected($event, result)">
        <div *ngIf="selectedWidgetKey === result.definition.key" class="drill-down-selection-card"
          [class.drill-down-selection-error]="!drillDownLoading && !!drillDownMessage">
          <div class="drill-down-selection-icon" aria-hidden="true">
            <i [class]="drillDownLoading ? 'fa fa-spinner fa-spin' : (drillDownMessage ? 'fa fa-info-circle' : 'fa fa-list-ul')"></i>
          </div>
          <div class="drill-down-selection-copy" aria-live="polite" [attr.aria-busy]="drillDownLoading">
            <div class="drill-down-selection-source">Selected from {{ result.definition.title }}</div>
            <div class="drill-down-selection-title">{{ selectedSelectionLabel }}</div>
            <div class="drill-down-selection-status" *ngIf="drillDownLoading">Finding matching records...</div>
            <div class="drill-down-selection-status" *ngIf="!drillDownLoading && drillDownMessage">{{ drillDownMessage }}</div>
            <div class="drill-down-selection-status" *ngIf="!drillDownLoading && !drillDownMessage && gridFilters">
              <ng-container *ngIf="selectedDrillDownCount !== null && selectedDrillDownCount !== undefined; else selectionReady">
                {{ selectedDrillDownCount }} matching record{{ selectedDrillDownCount === 1 ? '' : 's' }}
              </ng-container>
              <ng-template #selectionReady>Matching records are ready</ng-template>
            </div>
            <div class="drill-down-selection-status" *ngIf="!drillDownLoading && !drillDownMessage && !gridFilters">
              <ng-container *ngIf="selectedDataValueDisplay; else selectionPending">
                Chart value: <strong>{{ selectedDataValueDisplay }}</strong>
              </ng-container>
              <ng-template #selectionPending>Ready to find matching records</ng-template>
            </div>
          </div>
          <div class="drill-down-selection-actions">
            <button *ngIf="canOpenSelectedDetails" type="button" class="btn btn-primary btn-sm" (click)="openSelectedDetails()">
              <ng-container *ngIf="drillDownMessage && !gridFilters; else viewSelectedDetails">Try again</ng-container>
              <ng-template #viewSelectedDetails>View {{ currentDrillDown.title | lowercase }}</ng-template>
              <i class="fa fa-arrow-right" aria-hidden="true"></i>
            </button>
            <button type="button" class="btn drill-down-selection-dismiss" (click)="clearSelectedDetails()"
              aria-label="Clear selected chart data" title="Clear selection">
              <i class="fa fa-times" aria-hidden="true"></i>
            </button>
          </div>
        </div>
      </dw-chart-tile>
    </article>

    <article class="widget-card" *ngFor="let widget of customWidgets"
      [style.grid-column]="'span ' + widgetColumnSpan(widget)"
      [style.min-height.px]="widget.minimumHeightPixels">
      <div class="widget-header">
        <div>
          <h2>{{ widget.title }}</h2>
          <p *ngIf="widget.description">{{ widget.description }}</p>
        </div>
      </div>
      <app-report-custom-widget-host
        [definition]="widget"
        [filters]="currentFilters"
        [expressionContext]="expressionContext">
      </app-report-custom-widget-host>
    </article>
  </section>
</div>
